import FlagOutlined from '@mui/icons-material/FlagOutlined';
import { lighten } from '@mui/material';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { t } from 'i18next';

import { badgeSizes } from './AiReviewIndicator';

export default function FlaggedTicketIndicator() {
  return (
    <Tooltip title={t('loads.ticket_flagged')}>
      <span>
        <Box
          sx={(theme) => ({
            alignItems: 'center',
            backgroundColor: lighten(theme.palette.error.main, 0.95),
            border: `solid 1px ${theme.palette.error.main}`,
            borderRadius: '50%',
            display: 'flex',
            height: badgeSizes.md.box,
            justifyContent: 'center',
            width: badgeSizes.md.box,
          })}
        >
          <FlagOutlined
            sx={(theme) => ({
              color: theme.palette.error.main,
              height: badgeSizes.md.icon,
              width: badgeSizes.md.icon,
            })}
          />
        </Box>
      </span>
    </Tooltip>
  );
}
